import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transmission-and-reception',
  templateUrl: './transmission-and-reception.component.html',
  styleUrls: ['./transmission-and-reception.component.css']
})
export class TransmissionAndReceptionComponent implements OnInit {
  current_lang = localStorage.getItem('current_lang') || 'en';
  countryId = +localStorage.getItem('countryId');
  address = localStorage.getItem('address');

  lat = +localStorage.getItem('lat');
  long = +localStorage.getItem('lng');
  currencySymbol = (this.current_lang == 'en' ? localStorage.getItem('currencySymbolEn') : localStorage.getItem('currencySymbolAr')) || 'KWD'

  constructor() { }

  ngOnInit(): void {
  }

  handleLatLng(event: { lat: number; lng: number }) {
    this.lat = event.lat;
    this.long = event.lng;
  }
  getCountry(country){
    this.currencySymbol = this.current_lang == 'en' ? country.currencySymbolEn : country.currencySymbolAr
  }
  getCountryId(id) {
    localStorage.setItem('countryId', id);
    this.countryId = +id;
    // this.globalFilter(1, this.filter_input);
  }

  
}
